import { useCallback, useEffect, useState } from "react";
import { BasicTable } from "../components/tables/BasicTable";
import { Pagination } from "../components/pagination/Pagination";
import { useNavigate } from "react-router-dom";
import { Search } from "../components/search/Search";
import { useLocation } from "react-router-dom";
import { getAllTeams } from "../services/teamsAPI";
import Loader from "../components/ui/loader";

export const Teams = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const handleTeamClick = (teamID) => {
    navigate(`/team/${teamID}`);
  };

  const handleLeagueClick = (leagueID) => {
    navigate(`/league/${leagueID}`);
  };

  const columns = [
    { key: "TeamID", label: "ID", itemID: "TeamID", clickHandler: handleTeamClick },
    { key: "city", label: "City", itemID: "TeamID", clickHandler: handleTeamClick },
    { key: "name", label: "Name", itemID: "TeamID", clickHandler: handleTeamClick },
    {
      key: "LeagueDetails.name",
      label: "League",
      itemID: "LeagueDetails.LeagueID",
      clickHandler: handleLeagueClick,
    },
  ];

  const searchCategories = [
    { value: "id", label: "ID" },
    { value: "city", label: "City" },
    { value: "name", label: "Name" },
    { value: "league", label: "League" },
  ];

  const [teamsData, setTeamsData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const fetchTeams = useCallback(async () => {
    try {
      setIsLoading(true);
      let response = await getAllTeams(location.search);
      console.log(response);
      if (response.success) {
        setTeamsData(response.data.teams);
        setPagination(response.data.pagination);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchTeams();
  }, [fetchTeams]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh] bg-flyers-black">
        <Loader />
      </div>
    );
  }

  return (
    <div className="bg-flyers-black min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <h1 className="font-heading text-3xl font-black uppercase tracking-wide text-flyers-orange">
          Teams
        </h1>
        <Search categories={searchCategories} />
        <BasicTable columns={columns} data={teamsData} />
        <Pagination pagination={pagination} />
      </div>
    </div>
  );
};
